import "./_feature-banner-modules.scss"

export default class FeatureBanner {
  constructor(elem) {
    const self = this
    self.elem = elem
    return self
  }
}
